<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PrinterSelect',

  props: {
    value: { required: false, type: String, default: null },
    items: { required: true, type: Array as () => string[] },
    disabled: { required: false, type: Boolean, default: false }
  }
})
</script>

<template>
  <v-select
    :value="value"
    @input="$emit('input', $event)"
    :items="items"
    no-data-text="No printers found"
    placeholder="Default printer"
    :disabled="disabled"
    hide-details
    outlined
    dense
    background-color="#FFFFFF"
  />
</template>
